module.exports = __webpack_public_path__ + "static/media/idb-dropdown-arrow.d39e1f9e.svg";